import React from 'react';
import FceUsersPage from '../FceUsersPage';

const FceUsers = () => <FceUsersPage />;

export default FceUsers;
